
import React, { useState } from "react";
import "../styles.css";
import "./credit-card.css";
import ReactModal from "react-modal";
import { BoxModal } from "../../../../components/boxModal";
import { FilterButton } from "../../../../components/E-check/style";

export const ModalMfa = ({ handlePaymentConfirmation, data, setModalMfa, modalMfa, paymentLoader, setModalVoucher }) => {

  const [mfaCode, setMfaCode] = useState('');
  const handlePayment = async () => {
    try {
      await handlePaymentConfirmation(mfaCode, data);
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <ReactModal
      isOpen={modalMfa}
      className="change-modal"
      overlayClassName="overlay-pix-modal"
    >
      <BoxModal
        title="Digite o Código de Autenticação"
        close={() => setModalMfa(false)}
        maxWidth={400}
      >
        <div className="credit-card-container">
          <div
            className="card-form-section"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              gap: "1rem",
            }}
          >
            {/* FORMULÁRIO */}
            <div className="card-info-form" style={{ flex: 1, marginTop: "4px" }}>
              <div className="container-row">
                <input
                  id="name"
                  className="form-control"
                  name="cardholder"
                  maxLength="29"
                  type="text"
                  placeholder="Código de Autenticação"
                  value={mfaCode}
                  onChange={(e) => setMfaCode(e.target.value)}
                  required
                />
              </div>
            </div>
          </div>

          {/* BOTÕES */}
          <div className="row mt-4 align-items-center justify-content-start btn-area">
            <div className="col-md-3 button-area">
              {paymentLoader ? (
                <FilterButton
                  disabled
                >
                  <span className="sr-only">Loading...</span>
                </FilterButton>
              ) : (
                <FilterButton
                  onClick={() => handlePayment()}
                >
                  Concluir
                </FilterButton>
              )}

              <button
                type="button"
                className="btn btn-secondary w-44 ml-2"
                onClick={() => setModalMfa(false)}
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      </BoxModal>
    </ReactModal>
  );
};
